export default {
  redirect: String,
  customcss: String,
  sessionParam: String,
  sessionParamOld: String,
  customer: Number
};
